<template>
	<t-resizable-horizontal-panel :localStorageId="localStorageId" style="height:100%;width:100%">
		<deviation-types slot="left"/>
		<deviation-causes slot="right"/>
	</t-resizable-horizontal-panel>
</template>

<script>
import DeviationTypes from './DeviationTypes';
import DeviationCauses from './DeviationCauses';

export default {
	name: 'Deviations',
	components: { DeviationTypes, DeviationCauses },
	data() {
		return { localStorageId: 'maintenance/deviations' };
	},
};
</script>